import { render } from "./SavedTablesDialog.vue?vue&type=template&id=6526ebac"
import script from "./SavedTablesDialog.vue?vue&type=script&lang=js"
export * from "./SavedTablesDialog.vue?vue&type=script&lang=js"

import "./SavedTablesDialog.vue?vue&type=style&index=0&id=6526ebac&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QDialog});
